export type ScrollSnapshot = {
  element: HTMLElement;
  top: number;
  left: number;
};

export const getScrollableAncestors = (node: Element | null): ScrollSnapshot[] => {
  if (!(node instanceof HTMLElement)) {
    return [];
  }

  const snapshots: ScrollSnapshot[] = [];
  let current: HTMLElement | null = node;

  while (current) {
    const { overflowY, overflowX, overflow } = window.getComputedStyle(current);
    const canScrollY =
      (overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflow === 'auto' ||
        overflow === 'scroll') &&
      current.scrollHeight > current.clientHeight;
    const canScrollX =
      (overflowX === 'auto' ||
        overflowX === 'scroll' ||
        overflow === 'auto' ||
        overflow === 'scroll') &&
      current.scrollWidth > current.clientWidth;

    if (canScrollY || canScrollX) {
      snapshots.push({
        element: current,
        top: current.scrollTop,
        left: current.scrollLeft,
      });
    }

    current = current.parentElement;
  }

  return snapshots;
};
